import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useService(serviceId: Nullable<string>) {
	/** Hooks */

	/** Query */
	const query = useQuery({
		queryKey: ["service", serviceId || "unknown-service"],
		queryFn: async () => {
			if (!serviceId) throw new Error("Service ID is required");
			const response = await client.organizations.services[":serviceId"].$get({
				param: { serviceId },
			});
			const data = await responseHandler(response);
			return data.service;
		},
		enabled: !!serviceId,
	});

	return { ...query, service: query.data };
}
